import React, { useState, useEffect } from 'react';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import OptionsDataByAttributePath from 'Components/Options/optionsData/OptionsDataByAttributePath';
import Panel from 'Components/Panel/Panel';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';

const CollaboratorControl = ({
    onUpdateResetUserList,
    onUpdateUserSelected,
    usersSelected
}) => {
    const [sectors, setSectors] = useState([]);
    const [managers, setManagers] = useState([]);
    const [roles, setRoles] = useState([]);
    const [periods, setPeriods] = useState([]);
    const [profiles, profilesIds] = useState([]);
    const [loadingCollaboratorPanel, setLoadingCollaboratorPanel] = useState(null);

    const [userId, setUserId] = useState(null);
    const [employeeIdSelected, setEmployeeIdSelected] = useState(null);
    const [sectorSelected, setSectorSelected] = useState(null);
    const [managerSelected, setManagerSelected] = useState(null);
    const [totalWeeklyHours, setTotalWeeklyHours] = useState(null);
    const [roleSelected, setRoleSelected] = useState(null);
    const [cpf, setCpf] = useState(null);
    const [pis, setPis] = useState(null);
    const [admissionDate, setAdmissionDate] = useState(null);
    const [profileId, setProfileId] = useState(null);
    const [recessionDate, setRecessionDate] = useState(null);
    const [periodId, setPeriodId] = useState(null);
    const [isInternal, setIsInternal] = useState('S');
    const [username, setUsername] = useState(null);
    const [updateDate, setUpdateDate] = useState(null);
    const [collaboratorListAttributes, setCollaboratorListAttributes] = useState(null);

    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);

    const [selectedColor, setSelectedColor] = useState('#ffffff');

    const setPeriodValues = async () => {
        const fetchData = async () => {
            const periods = await ExecuteAxios.api('get', '/work-period/get-work-period-list/');
            setPeriods(periods);
        }
        fetchData()
    };

    useEffect(() => {
        setPeriodValues();
    }, []);
    const periodsOptions = OptionsDataByAttributePath(periods, ['description'], null, true);

    useEffect(() => {
        setInserting(false)
        setUpdating(false)
        const fetchData = async () => {
            const sectors = await ExecuteAxios.api('get', '/sector');
            setSectors(sectors);
        };

        if (usersSelected && usersSelected.length === 1) {
            setUserId(usersSelected[0])
        } else {
            setUserId(null)
        }

        fetchData();
    }, [usersSelected]);
    const sectorOptions = OptionsDataByAttributePath(sectors, ['description'], null, true);

    useEffect(() => {
        if (sectorSelected) {
            const fetchManagers = async () => {
                const parameters = {
                    roleId: null
                }
                const managers = await ExecuteAxios.api('get', `/employee/lookup-manager-and-employee/`, { params: parameters });
                if (managers) {
                    if (!getIfManagerSelectedHaveInManagerList(managers)) {
                        cleanManager();
                        setManagers(managers);
                    } else {
                        setManagers(managers);
                    }
                }
            };

            fetchManagers();
        } else {
            cleanManager();
        }
    }, [sectorSelected]);
    const managerOptions = OptionsDataByAttributePath(managers, ['description'], null, true);

    useEffect(() => {
        const fetchProfiles = async () => {
            const parameters = {
                roleId: null
            }
            const profiles = await ExecuteAxios.api('get', `/profile/get-profile-lookup/`, { params: parameters });
            profilesIds(profiles);
        }
        fetchProfiles()
    }, []);
    const profilesOptions = OptionsDataByAttributePath(profiles, ['description'], null, true);

    useEffect(() => {
        const fetchRoles = async () => {
            const managers = await ExecuteAxios.api('get', `/employee/lookup-role`);
            setRoles(managers);
        };

        fetchRoles();
    }, []);
    const rolesOptions = OptionsDataByAttributePath(roles, ['role'], null, true);

    const attributeList = [
        { name: "id", value: employeeIdSelected, setter: setEmployeeIdSelected },
        { name: "sector", value: sectorSelected, setter: setSectorSelected, comboboxOptions: sectorOptions },
        { name: "managerId", value: managerSelected, setter: setManagerSelected, comboboxOptions: managerOptions },
        { name: "roleId", value: roleSelected, setter: setRoleSelected, comboboxOptions: rolesOptions },
        { name: "cpf", value: cpf, setter: setCpf, columnType: 'checkbox' },
        { name: "profileId", value: profileId, setter: setProfileId, comboboxOptions: profilesOptions },
        { name: "totalWeeklyHours", value: totalWeeklyHours, setter: setTotalWeeklyHours },
        { name: "pis", value: pis, setter: setPis, columnType: 'checkbox' },
        { name: "admissionDate", value: admissionDate, setter: setAdmissionDate, columnType: 'checkbox' },
        { name: "recessionDate", value: recessionDate, setter: setRecessionDate, columnType: 'checkbox' },
        { name: "isInternal", value: isInternal, setter: setIsInternal, columnType: 'checkbox', resetValue: 'S' },
        { name: "periodId", value: periodId, setter: setPeriodId, comboboxOptions: periodsOptions },
        { name: "usernameUpdate", value: username, setter: setUsername, readOnly: true },
        { name: "dtUpdate", value: updateDate, setter: setUpdateDate, readOnly: true }
    ];

    const readOnlyAttributes = !(inserting || updating);

    const setEmployeeAttributes = async (userId) => {
        const parameters = { userId: userId }
        const employee = await ExecuteAxios.api('get', `/employee/employee-by-userId/`, { params: parameters });
        if (employee) {
            setCollaboratorListAttributes(employee)
            ApplyAttributes.applyAttributes(employee, attributeList)
        }

        if (!employee || !employee[0] || !employee[0].id) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    useEffect(() => {
        if (usersSelected.length === 1) {
            setEmployeeAttributes(usersSelected[0]);
        } else {
            setEmployeeAttributes(null);
        }
    }, [usersSelected, inserting, updating]);

    function getIfManagerSelectedHaveInManagerList(managers) {
        let response;
        managers.forEach(manager => {
            if (manager.id === managerSelected) {
                response = true;
            }
        });
        return response;
    }

    const cleanManager = () => {
        setManagers();
        setManagerSelected();
    }

    async function updateRoleControlEmployee() {
        try {
            setLoadingCollaboratorPanel(true)
            const response = await ExecuteAxios.api('put', '/employee/',
                {
                    id: employeeIdSelected,
                    userId: usersSelected[0],
                    sectorId: sectorSelected,
                    managerId: managerSelected,
                    roleId: roleSelected,
                    color: selectedColor,
                    isInternal: isInternal,
                    profileId: profileId,
                    totalWeeklyHours: totalWeeklyHours,
                    cpf: cpf,
                    pis: pis,
                    admissionDate: admissionDate,
                    workPeriodId: periodId

                });

                if (response) {
                    onUpdateResetUserList(true)
                }
    
                return response;
        } finally {
            setLoadingCollaboratorPanel(false)
        }
    }

    async function newRoleControlEmployee() {
        if (usersSelected && usersSelected.length !== 1) {
            return alert('Necessário selecionar 01 usuário para realizar alterações.');
        } else {
            try {
                setLoadingCollaboratorPanel(true)
                const response = await ExecuteAxios.api('post', '/employee/',
                    {
                        userId: usersSelected[0],
                        sectorId: sectorSelected,
                        managerId: managerSelected,
                        roleId: roleSelected,
                        profileId: profileId,
                        isInternal: isInternal,
                        totalWeeklyHours: totalWeeklyHours,
                        color: selectedColor,
                        cpf: cpf,
                        pis: pis,
                        admissionDate: admissionDate,
                        workPeriodId: periodId
                    });

                if (response) {
                    onUpdateResetUserList(true);
                }
                return response
            } finally {
                setLoadingCollaboratorPanel(false)
            }
        }
    }

    function cancelInserOrUpdating() {
        setUpdating(false);
        setInserting(false);
    }

    const userControlPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        zIndex: '1000',
        borderBottom: '2px solid rgb(204, 204, 204)'
    };

    return (
        <Panel
            style={userControlPanelStyle}
            setUpdating={setUpdating}
            setInserting={setInserting}
            inserting={inserting}
            updating={updating}
            enableEdit={true}
            canEdit={usersSelected.length === 1 && employeeIdSelected}
            putFunction={updateRoleControlEmployee}
            enableNewRecord={true}
            canNewRecord={usersSelected.length === 1 && !employeeIdSelected}
            postFunction={newRoleControlEmployee}
            canViewCRUD={true}
            readOnly={!(usersSelected && usersSelected.length === 1)}
            recordsSelected={usersSelected}
            viewOnlyOneRecordCRUD={true}
            resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
            dataListedAttributes={collaboratorListAttributes}
            attributeList={attributeList}
        >
            <>
                <LoadingIndicator loaded={!loadingCollaboratorPanel}>
                    <AutomaticallyListedAttributes
                        list={collaboratorListAttributes}
                        attributeList={attributeList}
                        readOnlyAttributes={readOnlyAttributes}
                    />
                </LoadingIndicator>
            </>
        </Panel>
    );
};

export default CollaboratorControl;